import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface MobileFilterDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  darkMode: boolean;
  children: React.ReactNode;
}

const MobileFilterDrawer: React.FC<MobileFilterDrawerProps> = ({ isOpen, onClose, darkMode, children }) => {
  useEffect(() => {
    if (isOpen) { document.body.style.overflow = 'hidden'; } else { document.body.style.overflow = 'unset'; }
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => { if (e.key === 'Escape' && isOpen) onClose(); };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      <div className="fixed inset-0 bg-appines-black/50 transition-opacity" onClick={onClose} aria-hidden="true" />
      <div className={`fixed inset-y-0 right-0 w-full max-w-sm transform transition-transform duration-300 ease-in-out shadow-xl ${darkMode ? 'bg-appines-petrol' : 'bg-appines-white'}`}>
        <div className={`flex items-center justify-between p-4 border-b ${darkMode ? 'border-appines-white/12' : 'border-[rgba(1,42,54,0.12)]'}`}>
          <h2 className={`text-lg font-semibold ${darkMode ? 'text-appines-white' : 'text-appines-petrol'}`}>Filtres</h2>
          <button onClick={onClose} className={`p-2 rounded-lg transition-colors ${darkMode ? 'text-appines-white/65 hover:text-appines-white hover:bg-appines-white/10' : 'text-appines-petrol/65 hover:text-appines-petrol hover:bg-[rgba(1,42,54,0.06)]'}`} aria-label="Fermer les filtres">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
      </div>
    </div>
  );
};

export default MobileFilterDrawer;
